import { Avatar, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import * as React from 'react';
import { formatDNI } from '../../../../helpers';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import BotonComponent from '../../../dashboard/components/BotonNuevo';

const CardEstudianteComponent = ({
  index,
  data,
  onBoletin,
  activo,
  onClose,
  onPress,
}) => {
  return (
    <Card
      onClick={onPress}
      sx={{
        '&:hover': onPress && {
          cursor: 'pointer',
          backgroundColor: blue[100],
        },
      }}
    >
      <CardContent sx={{ p: 1 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: index ? 'space-between' : 'center',
          }}
        >
          {index && (
            <Typography
              sx={{ fontSize: 14, fontWeight: 'bold' }}
              color="text.secondary"
              gutterBottom
            >
              {index}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
          }}
        >
          <Avatar
            alt={data.usuario.perfil.pnombre}
            src={
              data.usuario.perfil.avatar
                ? getFilesArchivos(data.usuario.perfil.avatar)
                : `static/images/${
                    data.usuario.perfil.gender ? 'userf.png' : 'userm.png'
                  }`
            }
            sx={{ width: 100, height: 100 }}
          />
          <Typography sx={{ fontWeight: 'bold', fontSize: '12pt', ml: 2 }}>
            {formatDNI(data.usuario.perfil.dni)}
            <br />
            {data.usuario.perfil.papellido}{' '}
            {data.usuario.perfil.sapellido ?? ''}
            <br />
            {data.usuario.perfil.pnombre} {data.usuario.perfil.snombre ?? ''}
          </Typography>
        </Box>
      </CardContent>
      {index && (
        <CardActions sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <BotonComponent text="Boletín" click={onBoletin} blue />
          {activo ? <BotonComponent text="Cerrar" click={onClose} red /> : null}
        </CardActions>
      )}
    </Card>
  );
};

export default CardEstudianteComponent;
